import { styled } from '@nykaa/ui-components';

export const TransitionOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.surface};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  display: flex;
  flex-direction: column;
`;

export const TransitionText = styled.p`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.subTitleMedium};
  text-align: center;
  margin: 0;
`;

export const LoaderContainer = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
`;

export const GifImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;